import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useTranslation } from "react-i18next";

import {
    GET,
    newFetch
} from '../../helpers/fetch'

import ProfileInfo from '../../components/UserProfile/ProfileInfo'
import ProfileDetail from '../../components/UserProfile/ProfileDetail'

const UserProfile = ({ history }) => {
    const { t } = useTranslation();
    const user = JSON.parse(localStorage.getItem('user'))
    const [associate, setAssociate] = useState(null)

    const fetchUser = async () => {
        let api_path = '/associate/aboutme'
        let response = await newFetch(GET, api_path)
        
        response.success && setAssociate(response.data)
    }

    useEffect(() => {
        if (user) {
            fetchUser()
        }
    }, [])

    return (
        <React.Fragment>
            {
                associate && <React.Fragment>
                    <ProfileInfo user={associate} />
                    <ProfileDetail user={associate} t={t} />
                    <div className="container py-3 d-flex align-items-center">
                        <button type="button" className="btn btn-design btn-brand btn-block" onClick={() => history.push('/profile/edit')}>{t('Edit Profile')}</button>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default withRouter(UserProfile)
